"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleTimeoffValidation = void 0;
var date_fns_1 = require("date-fns");
var yup = __importStar(require("yup"));
var ScheduleTimeoffValidation = function (eventValidation, startDate) {
    return yup.object(__assign({ startDate: yup
            .date()
            .min((0, date_fns_1.startOfDay)(startDate), 'Start Date must be today or later')
            .max(yup.ref('endDate'), 'Start Date must be before End Date')
            .required('Start Date is required'), endDate: yup
            .date()
            .min(yup.ref('startDate'), 'End Date must be after Start Date')
            .required('End Date is required'), notes: yup.string().nullable(), students: yup
            .array()
            .min(1, 'Select one option')
            .of(yup.string())
            .required('Please select at least one student') }, (eventValidation && {
        eventIcon: yup.string().required('Please select at least one event icon'),
        title: yup.string().required('Title is required'),
        courseWork: yup.string().required('Course Work is required'),
    })));
};
exports.ScheduleTimeoffValidation = ScheduleTimeoffValidation;
